import type React from "react";
import { cn } from "../utils/cn";

interface FlipsideIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  title?: string;
  dark?: boolean;
}

export function FlipsideIcon({ className, title = "Flipside Icon", dark, ...props }: FlipsideIconProps) {
  // Ensure title is never empty for accessibility
  const accessibleTitle = title || "Flipside Icon";

  return (
    <svg
      className={cn(className)}
      aria-label={accessibleTitle}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{accessibleTitle}</title>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.68631 1.34945L3.30428 4.45683C2.49723 4.92276 2 5.78398 2 6.71583V12.931C2 13.8629 2.49683 14.7237 3.30387 15.1896L9.94925 19.029L9.98457 11.1957C9.98858 10.3457 10.4433 9.56196 11.1793 9.13697L17.9812 5.2097L11.2949 1.34945C10.4878 0.883518 9.49336 0.883518 8.68631 1.34945ZM11.3226 13.6676V11.8749C11.3226 11.0811 11.7464 10.3479 12.4343 9.95224L18.0005 6.74774L17.9909 8.32812C17.9852 9.25435 17.4888 10.108 16.6866 10.5711L11.3226 13.668V13.6676ZM11.3226 16.4862V18.2805L16.677 15.1892C17.484 14.7233 17.9812 13.862 17.9812 12.9302V11.3606L12.4318 14.5647C11.7456 14.9612 11.3226 15.6936 11.3226 16.4862Z"
        fill={dark ? "white" : "black"}
      />
    </svg>
  );
}

export default FlipsideIcon;
